<template>
  <section>
    <FormRow :fieldNameArr="[$t('PI_CODE'), '']" :col1Required="true">
      <AutoComplete
        v-model="piCode"
        :placeholder="$t('PI_CODE')"
        element-id="piCode"
        @on-search="search"
        clearable
        :disabled="!canUpdate"
        slot="a"
      >
        <Option v-for="(item, index) in piCodeSourceList" :value="item" :key="index">{{ item }}</Option>
      </AutoComplete>
      <Button v-show="canUpdate" type="success" @click="add" slot="b">{{$t('ADD')}}</Button>
    </FormRow>
    <TablePage 
      :tableWidth="windowWidth"
      :columnsList="columnsList" 
      :resultList="piCodeList"
    ></TablePage>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo, AlertDelete } from "@/util/alert"
import { Translate } from "@/util/common"

export default {
  name: "PICodeMaintain",
  props: {
    piCodeList: {
      type: Array,
      default: () => [],
    },
    group: {
      type: Object,
      default: () => null,
    },
  },
  components: {

  },
  data() {
    return {
      piCode: "",
      piCodeSourceList: [],
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("COMMON_BUTTON_operation")
            return h('div', {
              domProps:{
                innerHTML:  text
              }
            })
          },
          key: "action",
          width: 120,
          align: "center",
          render: (h, params) => {
            let self = this
            return self.canUpdate
              ? h("Icon", {
                  props: {
                    type: "md-trash",
                    size: 28,
                  },
                  class: "text-delta-red",
                  on: {
                    click: () => {
                      self.remove(params.row)
                    },
                  },
                })
              : h("span")
          },
        },
        {
          title: this.$t('PI_CODE'),
          key: "piCode",
          maxWidth: 150,
        },
        {
          title: this.$t('COMPANY_CODE'),
          key: "companyName",
        },
        {
          title: this.$t('CITY'),
          key: "city",
          maxWidth: 250,
        },
      ],
    }
  },
  created() {
    let vueInstance = this
    vueInstance.$vendorHttp
      .get("/group-account/" + vueInstance.group.uuid + "/data-control/PI_CODE")
      .then((response) => {
        response.data._embedded.dataControlResourceList.forEach((piCode) => {
          buildPiCode(vueInstance, piCode)
        })
      })
      .catch(() => {})
  },
  methods: {
    ...mapGetters(["getUserProfile", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    search() {
    },
    add() {
      const vueInstance = this
      if (!vueInstance.piCode) {
        return AlertInfo(self, "請選擇PI代碼").then(() => {
          setTimeout(() => document.getElementById("piCode").focus(), 200)
        })
      } else {
        vueInstance.toggleLoading(true)
        vueInstance.$authHttp
          .get("data-control/PI_CODE?piCode=" + vueInstance.piCode)
          .then((response) => {
            vueInstance.toggleLoading(false)
            buildPiCode(vueInstance, response.data)
            vueInstance.$linkDataControl(
              vueInstance,
              "PI_CODE",
              response.data.objectKey,
              vueInstance.group.code,
              "GROUP_USER"
            )
          })
          .catch((error) => {
            if (error.response.status == 444) {
              let text = vueInstance.$buildErrorMessage(error)
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                text,
              })
            }
          })
      }
      vueInstance.piCode = ""
    },
    remove(item) {
      let vueInstance = this
      AlertDelete(vueInstance, `PI代碼 ${item.piCode}`)
        .then(() => {
          vueInstance.toggleLoading(true)
          vueInstance.$unlinkDataControl(vueInstance, "PI_CODE", item.piCode, vueInstance.group.code, "GROUP_USER")
          vueInstance.piCodeList.splice(item._index, 1)
        })
        .catch(() => {})
    },
  },
  computed: {
    canUpdate() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_PI_CODE_RELATION_AREA_MODIFIABLE")
      )
    }, 
    windowWidth() {
      return this.getWindowsWidth() - 50
    }   
  },
}

function buildPiCode(vueInstance, piCode) {
  let companyName = ""
  let city = ""
  piCode.attributes.forEach((attribute) => {
    if (attribute.key == "city") {
      city = attribute.value
    }
    if (attribute.key == "companyName") {
      companyName = attribute.value
    }
  })
  vueInstance.piCodeList.push({ piCode: piCode.objectKey, companyName: companyName, city: city })
}
</script>

<style scoped></style>
